/* Learn to Draw v2 theme script */
(function(){
"use strict";
var d=document,de=d.documentElement;
var red=window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches;
function $(s,r){return (r||d).querySelector(s)}
function $$(s,r){return [].slice.call((r||d).querySelectorAll(s))}
function ready(f){if(d.readyState!=="loading")f();else d.addEventListener("DOMContentLoaded",f)}
var CFG=window.LTD2||{};

/* focus trap helper */
var trapEl=null,lastFocus=null;
function focusables(el){return $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])',el).filter(function(x){return x.offsetParent!==null})}
d.addEventListener("keydown",function(e){
 if(!trapEl)return;
 if(e.key==="Escape"){e.preventDefault();var c=trapEl._close;if(c)c();return}
 if(e.key!=="Tab")return;
 var f=focusables(trapEl);if(!f.length)return;
 var a=f[0],z=f[f.length-1];
 if(e.shiftKey&&d.activeElement===a){e.preventDefault();z.focus()}
 else if(!e.shiftKey&&d.activeElement===z){e.preventDefault();a.focus()}
});
function openLayer(el,dim,cls,closeFn){
 lastFocus=d.activeElement;el.hidden=false;if(dim)dim.hidden=false;
 el._close=closeFn;trapEl=el;d.body.classList.add("ltd2-lock",cls);
 requestAnimationFrame(function(){el.classList.add("on");if(dim)dim.classList.add("on");var f=focusables(el);(f[0]||el).focus()});
}
function closeLayer(el,dim,cls){
 el.classList.remove("on");if(dim)dim.classList.remove("on");
 d.body.classList.remove("ltd2-lock",cls);trapEl=null;
 setTimeout(function(){el.hidden=true;if(dim)dim.hidden=true},red?0:300);
 if(lastFocus&&lastFocus.focus)lastFocus.focus();
}

/* toast */
var toastT;
function toast(msg){var t=$(".ltd2-toast");if(!t)return;t.textContent=msg;t.classList.add("on");clearTimeout(toastT);toastT=setTimeout(function(){t.classList.remove("on")},3200)}

/* cart drawer */
var cd,cdDim;
function setCartState(count){
 $$("[data-cart-count]").forEach(function(b){b.textContent=count;b.hidden=!count});
 $$(".cd-full,.cart-full").forEach(function(x){x.hidden=!count});
 $$(".cd-empty,.cart-empty").forEach(function(x){x.hidden=!!count});
}
function openCart(){if(!cd)return;openLayer(cd,cdDim,"cd-open",closeCart)}
function closeCart(){if(!cd||cd.hidden)return;closeLayer(cd,cdDim,"cd-open")}
function getCart(){return fetch((CFG.root||"/")+"cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.json()})}
function postJSON(url,body){return fetch(url,{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify(body)}).then(function(r){if(!r.ok)throw r;return r.json()})}
function fixQty(cart){
 // one purchase covers the whole home: never more than 1
 var it=cart.items&&cart.items[0];
 if(it&&it.quantity>1)return postJSON((CFG.root||"/")+"cart/change.js",{id:it.key,quantity:1});
 return Promise.resolve(cart);
}
function buy(form){
 var id=form.querySelector("[name=id]");id=id&&id.value;
 return getCart().then(function(cart){
  var inCart=cart.items.some(function(i){return String(i.variant_id)===String(id)});
  if(inCart){setCartState(1);openCart();toast(CFG.tAlready||"All 3 books are already in your cart.");return}
  return postJSON((CFG.root||"/")+"cart/add.js",{items:[{id:Number(id),quantity:1}]}).then(getCart).then(fixQty).then(function(){
   setCartState(1);openCart();toast(CFG.tAdded||"Added: all 3 Starfall Academy books.");
  });
 });
}
d.addEventListener("submit",function(e){
 var f=e.target;if(!f.classList||!f.classList.contains("ltd2-buy"))return;
 if(!window.fetch)return;
 e.preventDefault();
 var b=f.querySelector("button");if(b)b.disabled=true;
 buy(f).catch(function(){HTMLFormElement.prototype.submit.call(f)}).then(function(){if(b)b.disabled=false});
});
d.addEventListener("click",function(e){
 var o=e.target.closest&&e.target.closest("[data-cart-open]");
 if(o&&cd){e.preventDefault();openCart();return}
 var c=e.target.closest&&e.target.closest("[data-cd-close]");
 if(c){e.preventDefault();closeCart();return}
 var rm=e.target.closest&&e.target.closest("[data-cart-remove]");
 if(rm&&window.fetch){e.preventDefault();getCart().then(function(cart){
   var ps=cart.items.map(function(i){return postJSON((CFG.root||"/")+"cart/change.js",{id:i.key,quantity:0})});
   return Promise.all(ps)}).then(function(){setCartState(0)}).catch(function(){location.href=rm.getAttribute("href")||"/cart"});}
});


/* look inside lightbox */
var lb;
function openLB(panel,title){
 if(!lb||!panel)return;
 var tr=$(".lb-track",lb);tr.innerHTML="";
 $$(".pages figure",panel).forEach(function(fg){
  var im=$("img",fg),cap=$("figcaption",fg);var f=d.createElement("figure");var i=d.createElement("img");
  i.src=im.getAttribute("data-full")||im.currentSrc||im.src;i.alt=im.alt;f.appendChild(i);
  if(cap){var c=d.createElement("figcaption");c.textContent=cap.textContent;f.appendChild(c)}tr.appendChild(f)});
 $(".lb-top h2",lb).textContent=title||"";
 openLayer(lb,null,"lb-open",closeLB);tr.scrollLeft=0;
}
function closeLB(){if(!lb||lb.hidden)return;closeLayer(lb,null,"lb-open")}

ready(function(){
 cd=$("#ltd2-cart");cdDim=$(".cd-dim");lb=$("#ltd2-lb");
 if(cdDim)cdDim.addEventListener("click",closeCart);
 if(lb){$(".lb-x",lb).addEventListener("click",closeLB);
  var tr=$(".lb-track",lb);
  $(".lb-prev",lb).addEventListener("click",function(){tr.scrollBy({left:-tr.clientWidth*0.8,behavior:red?"auto":"smooth"})});
  $(".lb-next",lb).addEventListener("click",function(){tr.scrollBy({left:tr.clientWidth*0.8,behavior:red?"auto":"smooth"})});
  lb.addEventListener("click",function(e){if(e.target===lb)closeLB()});}
 $$("[data-lb]").forEach(function(b){b.addEventListener("click",function(e){e.preventDefault();var p=d.getElementById(b.getAttribute("data-lb"));var bl=p&&$(".bk-line b",p);openLB(p,bl?bl.textContent.replace(/\.$/,""):"")})});
 if(window.fetch&&cd){getCart().then(function(c){if(c.items[0]&&c.items[0].quantity>1)fixQty(c);setCartState(c.item_count?1:0)}).catch(function(){})}

 /* sticky bar */
 var bar=$("#sbar"),heroBtn=$("#hero-btn"),fin=$("#final-btn");
 if(bar){
  var heroIn=!!heroBtn,finIn=false,scrolled=false;
  var upd=function(){var on=(heroBtn?!heroIn:scrolled)&&!finIn;bar.classList.toggle("show",on);bar.setAttribute("aria-hidden",on?"false":"true");if(on)bar.removeAttribute("inert");else bar.setAttribute("inert","");d.body.classList.toggle("has-bar",on)};
  if("IntersectionObserver" in window){
   if(heroBtn)new IntersectionObserver(function(e){heroIn=e[0].isIntersecting;upd()}).observe(heroBtn);
   if(fin)new IntersectionObserver(function(e){finIn=e[0].isIntersecting;upd()}).observe(fin);
  }
  if(!heroBtn){var onS=function(){var s=(window.scrollY||de.scrollTop)>420;if(s!==scrolled){scrolled=s;upd()}};window.addEventListener("scroll",onS,{passive:true});onS()}
  upd();
 }

 /* drawing carousel */
 var fw=$(".fw");
 if(fw){var view=$(".fw-view",fw),track=$(".fw-track",fw),cards=$$(".fc",fw),dots=$$(".dots i",fw),N=dots.length,i=N,t=null,paused=false;
  var place=function(anim){var c=cards[i];if(!c)return;var x=c.offsetLeft+c.offsetWidth/2-view.clientWidth/2;track.style.transition=anim?"":"none";track.style.transform="translateX("+(-x)+"px)";
   cards.forEach(function(k,j){k.classList.toggle("on",j===i);if(!anim)k.style.transition="none"});var r=i%N;dots.forEach(function(dd,j){dd.className=j===r?"on":""});
   if(!anim){track.offsetHeight;cards.forEach(function(k){k.style.transition=""});track.style.transition=""}};
  var go=function(n){i=n;place(true)};
  track.addEventListener("transitionend",function(e){if(e.target!==track)return;if(i>=2*N){i-=N;place(false)}else if(i<N){i+=N;place(false)}});
  dots.forEach(function(dd,j){dd.addEventListener("click",function(){go(N+j);play()})});
  var stop=function(){if(t)clearInterval(t);t=null};
  var play=function(){if(red||paused||d.body.classList.contains("dz-open"))return;stop();t=setInterval(function(){go(i+1)},3200)};
  $(".prev",fw).addEventListener("click",function(){go(i-1);play()});$(".next",fw).addEventListener("click",function(){go(i+1);play()});
  view.addEventListener("mouseenter",stop);view.addEventListener("mouseleave",play);
  fw.addEventListener("focusin",stop);fw.addEventListener("focusout",play);
  var sx=null;view.addEventListener("touchstart",function(e){sx=e.touches[0].clientX;stop()},{passive:true});
  view.addEventListener("touchend",function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;sx=null;if(Math.abs(dx)>40)go(i+(dx<0?1:-1));paused=true;stop()},{passive:true});
  /* drawing close-up */
  var dz=$("#ltd2-dz");
  if(dz&&N){
   var real=cards.slice(N,2*N),zi=0,dimg=$(".dz-img",dz),dcap=$(".dz-cap",dz);
   var info=real.map(function(c){var im=$("img",c),fc=$("figcaption",c),bk=$("b",fc).textContent.trim(),nm=fc.textContent.replace(bk,"").replace("\u00b7","").trim();return{src:im.getAttribute("src"),alt:im.alt,name:nm.charAt(0).toUpperCase()+nm.slice(1),book:bk}});
   var show=function(){var x=info[zi];dimg.src=x.src;dimg.alt=x.alt;dcap.innerHTML="";var b=d.createElement("b");b.textContent=x.name;dcap.appendChild(b);dcap.appendChild(d.createTextNode(" \u00b7 "+x.book))};
   var closeDz=function(){if(dz.hidden)return;closeLayer(dz,null,"dz-open");setTimeout(play,350)};
   var openDz=function(j){zi=j;show();stop();openLayer(dz,null,"dz-open",closeDz);lastFocus=real[j]};
   real.forEach(function(c,j){c.removeAttribute("aria-hidden");c.tabIndex=0;c.setAttribute("role","button");c.setAttribute("aria-label","Open the close-up: "+info[j].name+", "+info[j].book);
    c.addEventListener("keydown",function(e){if(e.key==="Enter"||e.key===" "){e.preventDefault();openDz(j)}});
    c.addEventListener("focus",function(){view.scrollLeft=0;if(i%N!==j){i=N+j;place(!red)}})});
   cards.forEach(function(c,j){c.addEventListener("click",function(){openDz(j%N)})});
   $(".dz-x",dz).addEventListener("click",closeDz);
   $(".dz-prev",dz).addEventListener("click",function(){zi=(zi-1+N)%N;show()});
   $(".dz-next",dz).addEventListener("click",function(){zi=(zi+1)%N;show()});
   dz.addEventListener("click",function(e){if(e.target===dz||e.target.classList.contains("dz-stage")||e.target.classList.contains("dz-foot"))closeDz()});
   var zx=null;dz.addEventListener("touchstart",function(e){zx=e.touches[0].clientX},{passive:true});
   dz.addEventListener("touchend",function(e){if(zx===null)return;var dx=e.changedTouches[0].clientX-zx;zx=null;if(Math.abs(dx)>40){zi=(zi+(dx<0?1:-1)+N)%N;show()}},{passive:true});
  }
  window.addEventListener("resize",function(){place(false)});
  place(false);play();}

 /* rotating hero word */
 var rot=$(".rot");
 if(rot){var ws=$$(".rw",rot),k=0;
  // size the word box to the word on show, so line 1 has no gap
  var fit=function(el){if(rot.classList.contains("fit"))rot.style.width=el.offsetWidth+"px"};
  if(rot.closest(".hx")){rot.classList.add("fit");fit(ws[0]);window.addEventListener("resize",function(){fit(ws[k])})}
  if(!red&&ws.length>1)setInterval(function(){var a=ws[k];a.classList.remove("on");a.classList.add("out");k=(k+1)%ws.length;var b=ws[k];fit(b);setTimeout(function(){a.classList.remove("out");b.classList.add("on")},300)},2200)}

 /* pill tabs */
 var tabs=$$(".tabs[role=tablist] button");
 tabs.forEach(function(b,ix){
  b.addEventListener("click",function(){tabs.forEach(function(o){o.classList.remove("on");o.setAttribute("aria-selected","false");o.tabIndex=-1;var p=d.getElementById(o.dataset.p);if(p)p.hidden=true});b.classList.add("on");b.setAttribute("aria-selected","true");b.tabIndex=0;var p=d.getElementById(b.dataset.p);if(p)p.hidden=false});
  b.addEventListener("keydown",function(e){var n=null;if(e.key==="ArrowRight")n=tabs[(ix+1)%tabs.length];if(e.key==="ArrowLeft")n=tabs[(ix-1+tabs.length)%tabs.length];if(n){e.preventDefault();n.click();n.focus()}});
 });

 /* policy page: on this page list */
 var toc=$(".toc[data-auto]"),art=$(".legal");
 if(toc&&art){var hs=$$(".shopify-policy__body h2,.shopify-policy__body h3,.legal > h2",art).filter(function(h){return h.textContent.trim()});
  var ol=$("ol",toc);
  hs.forEach(function(h,n){if(!h.id)h.id="s"+(n+1);var li=d.createElement("li"),a=d.createElement("a");a.href="#"+h.id;a.textContent=h.textContent.trim();if(!n)a.className="on";li.appendChild(a);ol.appendChild(li)});
  toc.hidden=!hs.length;}
});
})();

/* Inside every quest: plays each icon once when the section scrolls into view (staggered by CSS --d),
   and again on hover or tap. No loop. Does nothing when reduced motion is on or IntersectionObserver is missing. */
(function(){
  var grid=document.querySelector('.bb-grid');
  if(!grid||!('IntersectionObserver' in window))return;
  if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var bbs=[].slice.call(grid.querySelectorAll('.bb'));
  grid.classList.add('mo');
  function play(b,now){
    b.classList.remove('play');b.classList.add('reset');void b.offsetWidth;b.classList.remove('reset');
    if(now)b.style.setProperty('--d','0s');
    b.classList.add('play');b._t=Date.now();
  }
  new IntersectionObserver(function(es,io){es.forEach(function(e){if(e.isIntersecting){bbs.forEach(function(b){play(b,false)});io.disconnect()}})},{threshold:.3}).observe(grid);
  bbs.forEach(function(b){
    function again(){if(b._t&&Date.now()-b._t<400)return;play(b,true)}
    b.addEventListener('mouseenter',again);
    b.addEventListener('click',again);
  });
  window.ltdQuestReplay=function(){bbs.forEach(function(b){b.style.removeProperty('--d');play(b,false)})};
})();

/* Learn to Draw: Look inside. A tapped book (a card or a hero cover) flies to the middle and its cover swings open,
   then the Look inside v4 stories viewer (ltd2-li-v4.js) starts for that book. Reduced motion: it opens straight away. */
(function(){var d=document,sv=d.getElementById('sv');if(!sv)return;var busy=false;
 var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
 function S(){return window.ltdStories}
 function geo(btn){var img=btn.querySelector('img'),r=img.getBoundingClientRect(),vw=window.innerWidth,vh=window.innerHeight;
  var w=Math.min((vw-40)/2,240),h=w*r.height/r.width,tx=(vw-w)/2,ty=(vh-h)/2;
  return {img:img,w:w,h:h,tx:tx,ty:ty,s:r.width/w,fx:r.left-tx,fy:r.top-ty}}
 function build(g){var f=d.createElement('div');f.className='ltd2-fly';f.setAttribute('aria-hidden','true');
  f.innerHTML='<div class="bg"></div><div class="bk"><div class="pg"></div><div class="cv"><div class="fr"><img alt=""></div><div class="bf"></div></div></div>';
  f.querySelector('.fr img').src=g.img.currentSrc||g.img.src;
  var b=f.querySelector('.bk');b.style.left=g.tx+'px';b.style.top=g.ty+'px';b.style.width=g.w+'px';b.style.height=g.h+'px';
  d.body.appendChild(f);return {f:f,bg:f.querySelector('.bg'),bk:b,cv:f.querySelector('.cv')}}
 function an(el,kf,ms,e){return el.animate(kf,{duration:ms,easing:e||'cubic-bezier(.2,.8,.2,1)',fill:'forwards'}).finished}
 var OE='cubic-bezier(.45,.05,.25,1)';
 function openBook(btn){if(busy||!sv.hidden||!S())return;var bk=btn.getAttribute('data-book'),img=btn.querySelector('img');
  if(reduce||!img||!img.animate){S().open(bk,0,btn);return}
  busy=true;var g=geo(btn),x=build(g),hb=btn.querySelector('.lk-book')||btn;hb.style.visibility='hidden';
  an(x.bg,[{opacity:0},{opacity:1}],350);
  an(x.bk,[{transform:'translate('+g.fx+'px,'+g.fy+'px) scale('+g.s+')'},{transform:'translate(0,0) scale(1)'}],450)
  .then(function(){return Promise.all([an(x.cv,[{transform:'rotateY(0deg)'},{transform:'rotateY(-180deg)'}],650,OE),an(x.bk,[{transform:'translate(0,0)'},{transform:'translate('+(g.w/2)+'px,0)'}],650,OE)])})
  .then(function(){S().open(bk,0,btn);hb.style.visibility='';return an(x.f,[{opacity:1},{opacity:0}],250)})
  .then(function(){x.f.remove();busy=false})
  .catch(function(){x.f.remove();hb.style.visibility='';busy=false;if(sv.hidden&&S())S().open(bk,0,btn)})}
 [].slice.call(d.querySelectorAll('.hx-fan .hf-bk[data-book],.lk-card[data-book]')).forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();openBook(b)})});
 // buying from the end card: close the viewer so the cart or the payment window is in front
 sv.addEventListener('submit',function(){if(S())S().close()},true);
})();
/* Learn to Draw: price card, "See everything inside" shows the rest of the ticks. Without JS every tick shows. */
(function(){var b=document.querySelector('.pc-tog'),m=document.getElementById('pc-more');if(!b||!m)return;
 m.hidden=true;b.hidden=false;
 b.addEventListener('click',function(){var o=b.getAttribute('aria-expanded')==='true';b.setAttribute('aria-expanded',o?'false':'true');m.hidden=o});
})();
/* Learn to Draw: once a bubble's icon motion has finished, drop the finished animations (their own "reset" class),
   so the still icon is painted exactly as before, not as a held animation frame. A hover or tap replays as usual. */
(function(){var g=document.querySelector('.bb-grid.mo');if(!g)return;
 g.addEventListener('animationend',function(e){var b=e.target.closest&&e.target.closest('.bb');if(!b||!b.classList.contains('play'))return;
  if(b.getAnimations&&b.getAnimations({subtree:true}).some(function(a){return a.playState==='running'}))return;
  b.classList.remove('play');b.classList.add('reset')});
})();
/* Learn to Draw: loop. Once the grid has come into view, the full set plays again (same stagger) about 2s after the last icon
   has finished, forever, also after the grid scrolls off screen. Only a hidden browser tab pauses it; it carries on when the tab is back.
   A tap or hover still replays one bubble at once; the next cycle then waits for it to finish. Reduced motion: no .mo, nothing runs. */
(function(){var g=document.querySelector('.bb-grid.mo');if(!g||!window.ltdQuestReplay||!('IntersectionObserver' in window))return;
 var seen=false,t=0,HOLD=2000;
 function busy(){return g.getAnimations?g.getAnimations({subtree:true}).some(function(a){return a.playState==='running'}):false}
 function ok(){return seen&&!document.hidden}
 function next(){clearTimeout(t);t=0;if(!ok())return;
  t=setTimeout(function(){t=0;if(!ok())return;if(busy())return;window.ltdQuestReplay()},HOLD)}
 g.addEventListener('animationend',function(){if(!busy())next()});
 function wake(){if(ok()&&!busy()&&!t)next()}
 new IntersectionObserver(function(es,io){es.forEach(function(e){if(e.isIntersecting){seen=true;io.disconnect();wake()}})},{threshold:.3}).observe(g);
 document.addEventListener('visibilitychange',function(){if(document.hidden){clearTimeout(t);t=0}else wake()});
})();
